import React, { useImperativeHandle, useState } from 'react';

import PropTypes from 'prop-types';

const ModalNew = React.forwardRef(({ getComponent }, innerRef) => {
    const [isOpen, setOpen] = useState(false);
    const [data, setData] = useState(null);

    useImperativeHandle(
        innerRef,
        () => ({
            open: (curData = null) => {
                setOpen(true);
                if (curData) {
                    setData(curData);
                }
            },
            close: () => {
                setOpen(false);
                if (data) {
                    setData(null);
                }
            },
        }),
        [data],
    );
    if (isOpen) {
        return getComponent?.(data) || data;
    }
    return null;
});
ModalNew.propTypes = {
    getComponent: PropTypes.func,
};
export default ModalNew;
